<div class="d-flex flex-column filter">
  <form
    [formGroup]="formFilter"
    (ngSubmit)="_filter()"
    [ngStyle]="{
      'border-radius': mannamegentOption !== 'clients' && mannamegentOption !== 'itineraries' ? '50rem' : '0px'
    }"
    [ngClass]="{ 'mt-3': mannamegentOption !== 'clients' && mannamegentOption !== 'itineraries' }"
    class="filter-box mt-3 d-flex justify-content-between align-items-center pl-1 pr-2 flex-wrap"
  >
  <button type="submit" hidden></button>

    <div  class="d-flex flex-wrap w-100">



    <ng-container *ngIf="mannamegentOption !== 'clients' && mannamegentOption !== 'itineraries'">
      <div
        *ngIf="
          mannamegentOption !== 'fidelity' &&
          mannamegentOption !== 'depositWarranty' &&
          mannamegentOption !== 'transactions' &&
          mannamegentOption !== 'payments' &&
          mannamegentOption !== 'request-receipts' &&
          mannamegentOption !== 'request-billed' &&
          mannamegentOption !== 'wallet' &&
          mannamegentOption !== 'flyItineraries'
        "
         class="d-flex flex-wrap flex-grow-1"

      >
        <div class="d-flex filter-pill ">
          <span class="date-logo " [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" style="width: 70px" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">
              Fecha in
            </p>
            <div class="d-flex pl-0">
              <input
                formControlName="dateFrom"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="dateFrom"
                placeholder="23/04/2019"
                autocomplete="off"
                #startDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>
        <div class="d-flex filter-pill">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" style="width: 80px" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">
              Fecha out
            </p>
            <div class="d-flex pl-0">
              <input
                formControlName="dateTo"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="dateTo"
                placeholder="23/04/2019"
                autocomplete="off"
                #endDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
              <!-- <input type="date" class="form-control btn-border-right date-form date-filter" formControlName="dateTo" placeholder="23/04/2019"> -->
            </div>
          </div>
        </div>
      </div>

      <!-- CUSTOM MI BILLETERA -->
      <div class="d-flex flex-wrap w-100" *ngIf="mannamegentOption === 'wallet'">
        <div class="filter-pill d-flex mr-2">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">Fecha desde</p>
            <div class="d-flex pl-0">
              <input
                formControlName="dateFrom"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="dateFrom"
                [placeholder]="placeholderDateForm"
                autocomplete="off"
                #startDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="filter-pill d-flex mr-2">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">Fecha hasta</p>
            <div class="d-flex pl-0">
              <input
                formControlName="dateTo"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="dateTo"
                [placeholder]="placeholderDateForm"
                autocomplete="off"
                #endDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="wallet_transaction_type_id" class="label-input-text mb-0">Tipo de movimiento</label>
          <select
            id="wallet_transaction_type_id"
            name="transaction_type_id"
            class="form-control input-text"
            formControlName="transaction_type_id"
            aria-label="select"
            aria-describedby="transaction_type_id"
          >
            <option [value]="null" selected>Todos</option>
            <ng-container *ngFor="let stat of transactionTypes">
              <option [value]="stat.id">{{ stat.description }}</option>
            </ng-container>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="wallet_status_id" class="label-input-text mb-0">Estado</label>
          <select
            id="wallet_status_id"
            name="status_id"
            class="form-control input-text"
            formControlName="status_id"
            aria-label="select"
            aria-describedby="status_id"
          >
            <option [value]="null" selected>Todos</option>
            <ng-container *ngFor="let stat of statusDepositWarrantys">
              <option [value]="stat.id">{{ stat.name }}</option>
            </ng-container>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="wallet_status_id" class="label-input-text mb-0">Producto</label>
          <select
            id="wallet_status_id"
            name="status_id"
            class="form-control input-text"
            formControlName="status_id"
            aria-label="select"
            aria-describedby="status_id"
          >
            <option [value]="null" selected>Todos</option>
            <ng-container *ngFor="let stat of statusDepositWarrantys">
              <option [value]="stat.id">{{ stat.name }}</option>
            </ng-container>
          </select>
        </div>
        <div class="filter-actions">
          <button
            class="btn btn-reset"
            (click)="reset()"
            [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BORRAR
          </button>
          <button
            aria-controls="false"
            class="btn btn-search"
            [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
            type="submit"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BUSCAR
          </button>
        </div>

      </div>

      <!-- CUSTOM FIDELIDAD (BLICKOINS) / SOLICITUDES DE FACTURACIÓN -->
      <div class="d-flex flex-wrap w-100" *ngIf="mannamegentOption === 'fidelity' || mannamegentOption === 'request-billed'">
        <div class="filter-pill d-flex mr-2">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">
              {{mannamegentOption === 'fidelity' ? 'Acreditación' : 'Creación'}}
            </p>
            <div class="d-flex pl-0">
              <input
                formControlName="dateAccreditation"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="dateAccreditation"
                [placeholder]="placeholderDateForm"
                autocomplete="off"
                #startDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="filter-pill d-flex mr-2">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">
              {{mannamegentOption === 'fidelity' ? 'Pago' : 'Actualización'}}
            </p>
            <div class="d-flex pl-0">
              <input
                formControlName="datePayment"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="datePayment"
                [placeholder]="placeholderDateForm"
                autocomplete="off"
                #endDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="status" class="label-input-text mb-0">Estado</label>
          <select
            id="status"
            name="status"
            class="form-control input-text"
            formControlName="status"
            aria-label="status"
            aria-describedby="status"
          >
            <option [value]="null" selected>Todos</option>
            <ng-container *ngIf="mannamegentOption === 'fidelity'">
              <ng-container *ngFor="let stat of fidelityStatus">
                <option [value]="stat.id">{{ stat.name }}</option>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="mannamegentOption === 'request-billed'">
                <option [value]="1">Solicitada</option>
                <option [value]="0">Facturada</option>
            </ng-container>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="itinerary_id" class="label-input-text mb-0">#File</label>
          <input
            id="itinerary_id"
            name="itinerary_id"
            class="form-control input-text"
            type="number"
            placeholder="Número file"
            formControlName="itinerary_id"
            aria-label="itinerary_id"
            aria-describedby="itinerary_id"
          />
        </div>

        <div class="filter-actions">
          <button
            class="btn btn-reset"
            (click)="reset()"
            [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BORRAR
          </button>
          <button
            aria-controls="false"
            class="btn btn-search"
            [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
            type="submit"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BUSCAR
          </button>
        </div>
      </div>

      <!-- CUSTOM DEPOSITO DE GARANTÍA -->
      <div class="d-flex flex-wrap w-100" *ngIf="mannamegentOption === 'depositWarranty'">
        <div class="filter-pill d-flex mr-2">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
              <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">
              Fecha
            </p>
            <div class="d-flex pl-0">
              <input
                formControlName="dateUpdate"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="dateUpdate"
                [placeholder]="placeholderDateForm"
                autocomplete="off"
                #startDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="transaction_type_id" class="label-input-text mb-0">Tipo</label>
          <select
            id="transaction_type_id"
            name="transaction_type_id"
            class="form-control input-text"
            formControlName="transaction_type_id"
            aria-label="select"
            aria-describedby="transaction_type_id"
          >
            <option [value]="null" selected>Todos</option>
            <ng-container *ngFor="let stat of transactionTypes">
              <option [value]="stat.id">{{ stat.description }}</option>
            </ng-container>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="status" class="label-input-text mb-0">Estado</label>
          <select
            id="status"
            name="status"
            class="form-control input-text"
            formControlName="status_id"
            aria-label="select"
            aria-describedby="status_id"
          >
            <option [value]="null" selected>Todos</option>
            <ng-container *ngFor="let stat of statusDepositWarrantys">
              <option [value]="stat.id">{{ stat.name }}</option>
            </ng-container>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="reference_id" class="label-input-text mb-0">Referencia</label>
          <input
            id="reference_id"
            name="reference_id"
            class="form-control input-text"
            type="number"
            formControlName="reference_id"
            aria-label="reference_id"
            aria-describedby="reference_id"
            placeholder="#Referencia"
          />
        </div>

        <div class="filter-actions">
          <button
            class="btn btn-reset"
            (click)="reset()"
            [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BORRAR
          </button>
          <button
            aria-controls="false"
            class="btn btn-search"
            [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
            type="submit"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BUSCAR
          </button>
        </div>
      </div>

      <!-- CUSTOM TRANSACCIONES -->
      <div class="d-flex flex-wrap w-100" *ngIf="mannamegentOption === 'transactions'">
        <div class="filter-pill d-flex mr-2">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">
              Fecha
            </p>
            <div class="d-flex pl-0">
              <input
                formControlName="date"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="date"
                [placeholder]="placeholderDateForm"
                autocomplete="off"
                #startDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="transaction_type_id" class="label-input-text mb-0">Tipo</label>
          <select
            id="transaction_type_id"
            name="transaction_type_id"
            class="form-control input-text"
            formControlName="transaction_type_id"
            aria-label="select"
            aria-describedby="transaction_type_id"
          >
            <option [value]="null" selected>Todos</option>
            <ng-container *ngFor="let stat of transactionTypes">
              <option [value]="stat.id">{{ stat.description }}</option>
            </ng-container>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="status" class="label-input-text mb-0">Estado</label>
          <select
            id="status"
            name="status"
            class="form-control input-text"
            formControlName="status_id"
            aria-label="select"
            aria-describedby="status_id"
          >
            <option [value]="null" selected>Todos</option>
            <ng-container *ngFor="let stat of statusDepositWarrantys">
              <option [value]="stat.id">{{ stat.name }}</option>
            </ng-container>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="reference_id" class="label-input-text mb-0">Referencia</label>
          <input
            id="reference_id"
            name="reference_id"
            class="form-control input-text"
            type="number"
            formControlName="reference_id"
            aria-label="reference_id"
            aria-describedby="reference_id"
            placeholder="#Referencia"
          />
        </div>

        <div class="filter-actions">
          <button
            class="btn btn-reset"
            (click)="reset()"
            [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BORRAR
          </button>
          <button
            aria-controls="false"
            class="btn btn-search"
            [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
            type="submit"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BUSCAR
          </button>
        </div>
      </div>

      <!-- CUSTOM VUELOS -->
      <div class="d-flex flex-wrap w-100" *ngIf="mannamegentOption === 'flyItineraries'">
        <div class="filter-pill d-flex mr-2">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">
              Fecha {{ formFilter.get("selectDate").value === "In" ? "llegada" : "salida" }}
            </p>
            <div class="d-flex pl-0">
              <input
                formControlName="dateUpdate"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="dateUpdate"
                [placeholder]="placeholderDateForm"
                autocomplete="off"
                #startDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="selectDate" class="label-input-text mb-0">Selección fecha</label>
          <select
            id="selectDate"
            name="selectDate"
            class="form-control input-text"
            formControlName="selectDate"
            aria-label="select"
            aria-describedby="selectDate"
          >
            <option [value]="null" disabled selected>Fechas</option>
            <option value="In">Fecha llegada</option>
            <option value="Out">Fecha salida</option>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="flyNumberIn" class="label-input-text mb-0">N° vuelo ida</label>
          <input
            id="flyNumberIn"
            name="flyNumberIn"
            class="form-control input-text"
            type="number"
            formControlName="flyNumberIn"
            aria-label="flyNumberIn"
            aria-describedby="flyNumberIn"
            placeholder="Número vuelo ida"
          />
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="flyNumberOut" class="label-input-text mb-0">N° vuelo vuelta</label>
          <input
            id="flyNumberOut"
            name="flyNumberOut"
            class="form-control input-text"
            type="number"
            formControlName="flyNumberOut"
            aria-label="flyNumberOut"
            aria-describedby="flyNumberOut"
            placeholder="Número vuelo vuelta"
          />
        </div>

        <div class="filter-actions">
          <button
            class="btn btn-reset"
            (click)="reset()"
            [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BORRAR
          </button>
          <button
            aria-controls="false"
            class="btn btn-search"
            [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
            type="submit"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BUSCAR
          </button>
        </div>
      </div>

      <!-- CUSTOM PAGOS -->
      <div class="d-flex flex-wrap w-100" *ngIf="mannamegentOption === 'payments'">
        <div class="filter-pill d-flex mr-2">
          <span class="date-logo mr-3" [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
            <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="30px" height="30px" alt="">
          </span>
          <div class="d-flex flex-column">
            <p class="date-text" [ngStyle]="{ 'border-bottom': '2px solid ' + styleSidebar?.background_color }">
              Fecha
            </p>
            <div class="d-flex pl-0">
              <input
                formControlName="date"
                type="text"
                class="form-control btn-border-right date-form date-filter"
                id="date"
                [placeholder]="placeholderDateForm"
                autocomplete="off"
                #startDateDp="bsDatepicker"
                bsDatepicker
                [minDate]="minDate"
                [maxDate]="maxDateArrival"
                [bsConfig]="dpConfig"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="itinerary_id" class="label-input-text mb-0">#File</label>
          <input
            id="itinerary_id"
            name="itinerary_id"
            class="form-control input-text"
            formControlName="itinerary_id"
            type="number"
            aria-label="itinerary_id"
            aria-describedby="itinerary_id"
            placeholder="#File"
          />
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="agency_id" class="label-input-text mb-0">Agencia</label>
          <select
            id="agency_id"
            name="agency_id"
            class="form-control input-text"
            formControlName="agency_id"
            aria-label="select"
            aria-describedby="agency_id"
          >
            <option [value]="null" selected>Todas</option>
            <ng-container *ngFor="let agency of agencies">
              <option [value]="agency.id">{{ agency.name }}</option>
            </ng-container>
          </select>
        </div>

        <div class="filter-pill d-flex flex-column mr-2">
          <label for="agent_id" class="label-input-text mb-0">Agente</label>
          <select
            id="agent_id"
            name="agent_id"
            class="form-control input-text"
            formControlName="agent_id"
            aria-label="agent_id"
            aria-describedby="agent_id"
          >
            <option [value]="null" selected>Todos</option>
          </select>
        </div>

        <div class="filter-actions">
          <button
            class="btn btn-reset"
            (click)="reset()"
            [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BORRAR
          </button>
          <button
            aria-controls="false"
            class="btn btn-search"
            [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
            type="submit"
            [disabled]="modelMannagementOptionLength === 0"
          >
            BUSCAR
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="mannamegentOption === 'clients' || mannamegentOption === 'itineraries'">
      <div class="d-flex flex-column w-100 ml-2 py-5" *ngIf="mannamegentOption === 'clients'">
        <div class="d-flex w-100 mb-4">
          <div class="col-4 d-flex w-100 flex-column">
            <label for="name" class="label-input-text w-100 mb-1">Nombre</label>
            <input
              id="name"
              name="name"
              class="form-control input-text w-100"
              formControlName="name"
              type="text"
              aria-label="name"
              aria-describedby="name"
              placeholder="NOMBRE"
            />
          </div>
          <div class="col-4 d-flex flex-column w-100">
            <label for="email" class="label-input-text mb-1 w-100">email</label>
            <input
              id="email"
              name="email"
              class="form-control input-text w-100"
              formControlName="email"
              type="text"
              aria-label="email"
              aria-describedby="email"
              placeholder="EMAIL"
            />
          </div>
          <div class="col-4 d-flex flex-column w-100">
            <label for="type" class="label-input-text mb-1 w-100">N° documento</label>
            <input
              id="document_number"
              name="document_number"
              class="form-control input-text w-100"
              formControlName="document_number"
              type="text"
              aria-label="document_number"
              aria-describedby="document_number"
              placeholder="N° DOCUMENTO"
            />
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="col-4 d-flex flex-column w-100">
            <div class="d-flex flex-column">
              <label for="birth_date" class="label-input-text mb-1 w-100">Fecha de nacimiento</label>
              <div class="d-flex pl-0">
                <input
                  formControlName="birth_date"
                  type="text"
                  class="form-control w-100 input-text"
                  id="dateFrom"
                  placeholder="FECHA DE NACIMIENTO"
                  autocomplete="off"
                  #startDateDp="bsDatepicker"
                  bsDatepicker
                  [minDate]="minDate"
                  [maxDate]="maxDateArrival"
                  [bsConfig]="dpConfig"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="col-4 d-flex flex-column w-100">
            <label for="type" class="label-input-text mb-1 w-100">Género</label>
            <select
              id="gender"
              name="gender"
              class="form-control input-text w-100"
              formControlName="gender"
              aria-label="gender"
              aria-required="gender"
              autocomplete="off"
              required
            >
              <option value="null" selected disabled>GÉNERO</option>
              <option value="F">Femenino</option>
              <option value="M">Masculino</option>
              <option value="X">No Especificado</option>
              <option value="U">Prefiero no decirlo</option>
            </select>
          </div>
          <div class="col-4 d-flex mt-2 align-items-center w-100">
            <button
              class="btn rounded-pill mr-4 btn-reset"
              [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
              style="width: 100% !important"
              (click)="reset()"
            >
              BORRAR
            </button>
            <button
              aria-controls="false"
              class="btn rounded-pill btn-search"
              [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
              style="width: 100% !important"
              type="submit"
            >
              BUSCAR
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column w-100 ml-2 py-5" *ngIf="mannamegentOption === 'itineraries'">
        <div class="d-flex flex-wrap w-100 mb-4">
          <div class="col-4 d-flex flex-column w-100">
            <label for="products" class="label-input-text mb-1 w-100">#FILE</label>
            <input
              id="itinerary_id"
              name="itinerary_id"
              class="form-control input-text w-100"
              [ngClass]="{ 'date-selected': dateSelected }"
              type="number"
              inputmode="numeric"
              pattern="[0-9]*"
              min="0"
              placeholder="NÚMERO FILE"
              formControlName="itinerary_id"
              aria-label="itinerary_id"
              aria-describedby="itinerary_id"
              (wheel)="$event.preventDefault()"
            />
          </div>

          <div class="col-4 d-flex flex-column w-100">
            <div class="d-flex flex-column">
              <label for="seller" class="label-input-text mb-1 w-100">Vendedor</label>
              <input
                id="seller"
                name="seller"
                class="form-control input-text w-100"
                formControlName="seller"
                type="text"
                aria-label="seller"
                aria-describedby="seller"
                placeholder="VENDEDOR"
                (input)="validateText($event)"
              />
            </div>
          </div>

          <div class="col-4 d-flex w-100 flex-column">
            <label for="type_operation" class="label-input-text mb-1 w-100">TIPO DE FILE</label>
            <select
              id="status_id"
              name="status_id"
              class="form-control input-text w-100"
              formControlName="status_id"
              aria-label="status_id"
              aria-required="status_id"
              autocomplete="off"
            >
              <option value="null" selected disabled>TIPO DE FILE</option>
              <ng-container *ngFor="let status of statusList">
                <option [value]="status.id">{{ status.name }}</option>
              </ng-container>
            </select>
          </div>

        </div>

        <div class="d-flex w-100 mb-4">
          <div class="col-4 d-flex w-100 flex-column">
            <label for="dateRange" class="label-input-text w-100 mb-1">FECHA DE VIAJE</label>
            <input
              id="dateRange"
              name="dateRange"
              class="form-control input-text w-100"
              formControlName="dateRange"
              type="text"
              bsDaterangepicker
              [bsConfig]="dpConfig"
              placeholder="FECHA DE INICIO - FECHA DE FINALIZACIÓN"
              autocomplete="off"
            />
          </div>

          <div class="col-4 d-flex flex-column w-100">
            <label for="products" class="label-input-text mb-1 w-100">LOCALIZADOR</label>
            <input
              id="idReservation"
              name="idReservation"
              class="form-control input-text w-100"
              formControlName="idReservation"
              type="text"
              aria-label="idReservation"
              aria-describedby="idReservation"
              placeholder="LOCALIZADOR"
            />
          </div>

          <div class="col-4 d-flex flex-column w-100">
            <div class="d-flex flex-column">
              <label for="nameClient" class="label-input-text mb-1 w-100">Pasajero</label>
              <input
                id="nameClient"
                name="nameClient"
                class="form-control input-text w-100"
                formControlName="nameClient"
                type="text"
                aria-label="nameClient"
                aria-describedby="nameClient"
                placeholder="PASAJERO"
                (input)="validateText($event)"
              />
            </div>
          </div>
          <!-- <div class="col-4 d-flex flex-column w-100">
            <label for="expirationDate" class="label-input-text mb-1 w-100">FECHA DE EXPIRACIÓN</label>
            <input
              id="expirationDate"
              name="expirationDate"
              class="form-control w-100 input-text"
              type="text"
              formControlName="expirationDate"
              autocomplete="off"
              #startDateDp="bsDatepicker"
              bsDatepicker
              [bsConfig]="dpConfig"
              placeholder="FECHA DE EXPIRACIÓN"
            />
          </div> -->
        </div>

        <div class="d-flex align-items-center">
          <!-- <div class="col-4 d-flex flex-column w-100">
            <label for="creationDate" class="label-input-text mb-1 w-100">FECHA DE CREACIÓN</label>
            <input
              id="created_at"
              name="created_at"
              class="form-control input-text w-100"
              formControlName="created_at"
              #startDateDp="bsDatepicker"
              bsDatepicker
              [bsConfig]="dpConfig"
              type="text"
              aria-label="created_at"
              aria-describedby="created_at"
              placeholder="FECHA DE CREACIÓN"
            />
          </div> -->

          <div class="col-4 d-flex flex-column w-100">
            <label for="emailClient" class="label-input-text mb-1 w-100">Email del Pasajero</label>
            <div class="d-flex pl-0">
              <input
                id="emailClient"
                name="emailClient"
                class="form-control input-text w-100"
                formControlName="emailClient"
                type="text"
                aria-label="emailClient"
                aria-describedby="emailClient"
                placeholder="EMAIL DEL PASAJERO"
              />
            </div>
          </div>


      </div>

      <div class="d-flex flex-column align-items-end mt-3">
            <div class="col-4 d-flex mt-2 align-items-center w-100">
              <button
                class="btn rounded-pill mr-4 btn-reset"
                style="width: 100% !important"
                [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
                (click)="reset()"
                [disabled]="modelMannagementOptionLength === 0"
              >
                BORRAR
              </button>
              <button
                aria-controls="false"
                class="btn rounded-pill btn-search"
                style="width: 100% !important"
                [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
                type="submit"
                [disabled]="modelMannagementOptionLength === 0"
              >
                BUSCAR
              </button>
            </div>
          </div>
        </div>
    </ng-container>

    <div
      *ngIf="
        mannamegentOption !== 'clients' &&
        mannamegentOption !== 'itineraries' &&
        mannamegentOption !== 'wallet' &&
        mannamegentOption !== 'fidelity' &&
        mannamegentOption !== 'request-billed' &&
        mannamegentOption !== 'depositWarranty' &&
        mannamegentOption !== 'transactions' &&
        mannamegentOption !== 'flyItineraries' &&
        mannamegentOption !== 'payments'
      "
      class="filter-actions mt-2 align-items-center"
    >
      <button
        class="btn rounded-pill btn-reset"
        (click)="reset()"
        [ngStyle]="{ 'background-color': styleSidebar?.background_color, color: styleSidebar?.color }"
        [disabled]="modelMannagementOptionLength === 0"
      >
        BORRAR
      </button>
      <button
        aria-controls="false"
        class="btn rounded-pill btn-search"
        [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_3, color: buttonTextActive }"
        type="submit"
        [disabled]="modelMannagementOptionLength === 0"
      >
        BUSCAR
      </button>
    </div>

     </div>
  </form>
</div>
